import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import { useState } from "react";
import type SearchModalComponent from "./SearchModal";

// Loaded on first open so the modal (with its date pickers and react-responsive-modal)
// stays out of the shared layout bundle that every page downloads.
const SearchModal = dynamic(() => import("./SearchModal"), { ssr: false });

export default function LazySearchModal(
  props: ComponentProps<typeof SearchModalComponent>,
) {
  const [hasOpened, setHasOpened] = useState(props.open);
  if (props.open && !hasOpened) setHasOpened(true);

  return hasOpened ? <SearchModal {...props} /> : null;
}
